












import Vue from 'vue';
import ElementUI from 'element-ui';

export default Vue.extend({
    data() {
        return {};
    },
    computed: {
        show(): boolean {
            return this.$store.state.mainSearchbar;
        },
        searchKeyword: {
            get(): string {
                return this.$store.state.searchKeyword;
            },
            set(val) {
                this.$store.commit('searchKeyword', val);
            },
        },
    },
    methods: {
        search() {
            this.$router.push({
                path: '/search-results',
                query: {
                    keyword: this.searchKeyword as string,
                },
            });

            (this.$refs.search as ElementUI.Input).blur();
        },
    },
});
